import { Divider, Flex, Tag, Typography } from "antd"

import "../../styles.less"

const { Text } = Typography

const StepSectionHeader = ({ title, completed, total }) => {
  return (
    <Flex className="step_section_header" align="center" gap={12}>
      <Text type="secondary">{title}</Text>
      <Divider style={{ flex: 1, minWidth: 20 }} />
      {completed === total ? (
        <Tag className="step-status step-status--green">
          {completed} / {total} completed
        </Tag>
      ) : (
        <Tag className="step-status step-status--blue">
          {completed} / {total} completed
        </Tag>
      )}
    </Flex>
  )
}

export default StepSectionHeader
